import {Divider, Grid, Typography} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {GridRow, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {getGPLUEligibilityBlockPropertyPaths} from '../PropertyPaths';

export const GPLUEligibilityBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = getGPLUEligibilityBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'row-c0fe7741-cbc7-45fc-9d18-852a63188b34'},
      title: 'NEW PARTICIPANTS',
      items: [
        {
          key: '4cd07dee-b669-4ba4-b9e6-605843382e1b',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Min Hourly Requirement (Hours Per Week)"
              id={propertyPaths.minHourlyReq}
              value={getQuoteFieldValue(propertyPaths.minHourlyReq)}
              onChange={e => updateQuoteFieldValue(propertyPaths.minHourlyReq, e.target.value)}
              type="number"
              disabled
            />
          ),
        },
      ],
    },
    {
      rowProps: {key: 'row-413fa4bd-5525-4848-8e88-3800ca115ed4'},
      title: 'ISSUE AGES',
      items: [
        {
          key: 'c3956998-d040-43c5-a6a6-bc62f4b5e7a3',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Minimum Issue Age"
              id={propertyPaths.minIssueAge}
              value={getQuoteFieldValue(propertyPaths.minIssueAge)}
              onChange={e => updateQuoteFieldValue(propertyPaths.minIssueAge, e.target.value)}
              type="number"
              disabled
              required
            />
          ),
        },
        {
          key: 'ae3e5639-070e-47cf-9444-33d248d32296',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Maximum Issue Through Age"
              id={propertyPaths.maxIssueAge}
              value={getQuoteFieldValue(propertyPaths.maxIssueAge)}
              onChange={e => updateQuoteFieldValue(propertyPaths.maxIssueAge, e.target.value)}
              type="number"
              disabled
              required
            />
          ),
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Eligibility" collapsible withSeparator>
      <Grid container alignItems="center" style={{maxWidth: '100%'}}>
        {rows.map(
          ({items, rowProps, title, hidden}, index) =>
            !hidden && (
              <React.Fragment key={rowProps?.key}>
                {title && (
                  <>
                    <Typography variant="body1" style={{paddingLeft: '15px'}} className="lbl-main">
                      {title}
                    </Typography>
                    <Grid item xs={12}>
                      <Divider style={{width: '100%', margin: '10px 0', color: '#2F3847'}} />
                    </Grid>
                  </>
                )}
                <GridRow items={items} rowProps={rowProps} />
              </React.Fragment>
            )
        )}
      </Grid>
    </FormWrapper>
  );
};
